// components/Registration/FamilyDetailsStep.js
import React, { useEffect } from "react";
import { TextField } from "@mui/material";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { styled, lighten, darken } from '@mui/system';

export default function ProfessionDetailsStep({ formData, setFormData, validateError }) {
  const [isOtherOccupation, setIsOtherOccupation] = React.useState(false);
  const [isOtherEducation, setIsOtherEducation] = React.useState(false);
  const [isOtherSector, setIsOtherSector] = React.useState(false);

  const sectors = [
    { title: "Private Sector - IT/Software", value: "Private Sector - IT/Software" },
    { title: "Private Sector - MNC", value: "Private Sector - MNC" },
    { title: "Private Sector - Corporate", value: "Private Sector - Corporate" },
    { title: "Private Sector - Others", value: "Private Sector - Others" },

    { title: "Government - Central Government", value: "Government - Central Government" },
    { title: "Government - State Government", value: "Government - State Government" },
    { title: "Government - PSU (Public Sector Undertaking)", value: "Government - PSU" },
    { title: "Government - Defence", value: "Government - Defence" },
    { title: "Government - Others", value: "Government - Others" },

    { title: "Business / Self-Employed", value: "Business / Self-Employed" },
    { title: "Not Working", value: "Not Working" },
    { title: "Others", value: "Others" },
  ];

  const incomeRanges = [
    { value: "0-5", title: "₹0 to ₹5 Lakh yearly" },
    { value: "5-10", title: "₹5 Lakh to ₹10 Lakh yearly" },
    { value: "10-25", title: "₹10 Lakh to ₹25 Lakh yearly" },
    { value: "25-50", title: "₹25 Lakh to ₹50 Lakh yearly" },
    { value: "50-75", title: "₹50 Lakh to ₹75 Lakh yearly" },
    { value: "75-100", title: "₹75 Lakh to ₹1 Cr yearly" },
    { value: "100+", title: "₹1 Cr+ yearly" },
    { value: "prefer-not-to-say", title: "Prefer not to say" }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const occupations = [
    { title: "CxO / Chairman / Director / President", value: "CxO / Chairman / Director / President" },
    { title: "VP / AVP / GM / DGM", value: "VP / AVP / GM / DGM" },
    { title: "Sr. Manager / Manager", value: "Sr. Manager / Manager" },
    { title: "Consultant / Supervisor / Team Leads", value: "Consultant / Supervisor / Team Leads" },
    { title: "Team Member / Staff", value: "Team Member / Staff" },

    { title: "Air Hostess / Flight Attendant", value: "Air Hostess / Flight Attendant" },
    { title: "Pilot / Co-Pilot", value: "Pilot / Co-Pilot" },

    { title: "Architect", value: "Architect" },
    { title: "Interior Designer", value: "Interior Designer" },
    { title: "Landscape Architect", value: "Landscape Architect" },

    { title: "Animator", value: "Animator" },
    { title: "Commercial Artist", value: "Commercial Artist" },
    { title: "Web / UX Designers", value: "Web / UX Designers" },

    { title: "Beautician", value: "Beautician" },
    { title: "Fashion Designer", value: "Fashion Designer" },
    { title: "Hairstylist", value: "Hairstylist" },
    { title: "Jewellery Designer", value: "Jewellery Designer" },

    { title: "Customer Support / BPO / KPO Professional", value: "Customer Support / BPO / KPO Professional" },

    { title: "IAS / IRS / IES / IFS", value: "IAS / IRS / IES / IFS" },
    { title: "Indian Police Services [IPS]", value: "Indian Police Services [IPS]" },

    { title: "Airforce", value: "Airforce" },
    { title: "Army", value: "Army" },
    { title: "Navy", value: "Navy" },

    { title: "Lecturer", value: "Lecturer" },
    { title: "Professor", value: "Professor" },
    { title: "Research Assistant", value: "Research Assistant" },
    { title: "Research Scholar", value: "Research Scholar" },
    { title: "Teacher", value: "Teacher" },

    { title: "Civil Engineer", value: "Civil Engineer" },
    { title: "Electronics / Telecom Engineer", value: "Electronics / Telecom Engineer" },
    { title: "Mechanical / Production Engineer", value: "Mechanical / Production Engineer" },

    { title: "Chef / Sommelier / Food Critic", value: "Chef / Sommelier / Food Critic" },
    { title: "Catering Professional", value: "Catering Professional" },

    { title: "Software Developer / Programmer", value: "Software Developer / Programmer" },
    { title: "Software Consultant", value: "Software Consultant" },
    { title: "Hardware & Networking professional", value: "Hardware & Networking professional" },

    { title: "Lawyer", value: "Lawyer" },
    { title: "Legal Assistant", value: "Legal Assistant" },

    { title: "Dentist", value: "Dentist" },
    { title: "Doctor", value: "Doctor" },
    { title: "Medical Transcriptionist", value: "Medical Transcriptionist" },
    { title: "Nurse", value: "Nurse" },
    { title: "Pharmacist", value: "Pharmacist" },
    { title: "Physician Assistant", value: "Physician Assistant" },
    { title: "Physiotherapist / Occupational Therapist", value: "Physiotherapist / Occupational Therapist" },
    { title: "Psychologist", value: "Psychologist" },
    { title: "Surgeon", value: "Surgeon" },
    { title: "Veterinary Doctor", value: "Veterinary Doctor" },

    { title: "Merchant Naval Officer", value: "Merchant Naval Officer" },
    { title: "Mariner", value: "Mariner" },

    { title: "Marketing Professional", value: "Marketing Professional" },
    { title: "Sales Professional", value: "Sales Professional" },

    { title: "Biologist / Botanist", value: "Biologist / Botanist" },
    { title: "Physicist", value: "Physicist" },

    { title: "Others", value: "Others" },
  ];

  // Sort the occupations array by category
  occupations.sort((a, b) => {
    if (a.category < b.category) {
      return -1;
    }
    if (a.category > b.category) {
      return 1;
    }
    return 0;
  });

  const educationOptions = [
    { title: "High School", value: "High School" },
    { title: "Higher Secondary", value: "Higher Secondary" },
    { title: "Diploma", value: "Diploma" },
    { title: "Bachelor's Degree", value: "Bachelor's Degree" },
    { title: "Master's Degree", value: "Master's Degree" },
    { title: "MBA", value: "MBA" },
    { title: "MCA", value: "MCA" },
    { title: "B.Tech", value: "B.Tech" },
    { title: "M.Tech", value: "M.Tech" },
    { title: "MBBS", value: "MBBS" },
    { title: "MD", value: "MD" },
    { title: "PhD", value: "PhD" },
    { title: "CA (Chartered Accountant)", value: "CA" },
    { title: "CS (Company Secretary)", value: "CS" },
    { title: "ICWA", value: "ICWA" },
    { title: "LLB", value: "LLB" },
    { title: "LLM", value: "LLM" },
    { title: "B.Arch", value: "B.Arch" },
    { title: "M.Arch", value: "M.Arch" },
    { title: "B.Sc", value: "B.Sc" },
    { title: "M.Sc", value: "M.Sc" },
    { title: "B.Com", value: "B.Com" },
    { title: "M.Com", value: "M.Com" },
    { title: "BA", value: "BA" },
    { title: "MA", value: "MA" },
    { title: "BBA", value: "BBA" },
    { title: "BCA", value: "BCA" },
    { title: "Others", value: "Others" },
  ];

  const GroupHeader = styled('div')(({ theme }) => ({
    fontSize: '20px',
    padding: '10px',
    fontWeight: 'bolder'
  }));

  const GroupItems = styled('ul')({
    padding: 0,
  });

  useEffect(() => {
    if (formData.occup) {
      if (typeof formData.occup === "string") {
        setIsOtherOccupation(true); // manual entered text
      } else if (formData.occup.value === "Others") {
        setIsOtherOccupation(true);
      } else {
        setIsOtherOccupation(false);
      }
    } else {
      setIsOtherOccupation(false);
    }
  }, [formData.occup]);

  useEffect(() => {
    if (formData.educ) {
      if (typeof formData.educ === "string") {
        setIsOtherEducation(true); // manual entered text
      } else if (formData.educ.value === "Others") {
        setIsOtherEducation(true);
      } else {
        setIsOtherEducation(false);
      }
    } else {
      setIsOtherEducation(false);
    }
  }, [formData.educ]);

  useEffect(() => {
    if (formData.work_sector) {
      if (typeof formData.work_sector === "string") {
        setIsOtherSector(true); // manual entered text
      } else if (formData.work_sector.value === "Others") {
        setIsOtherSector(true);
      } else {
        setIsOtherSector(false);
      }
    } else {
      setIsOtherSector(false);
    }
  }, [formData.work_sector]);

  return (
    <div>
      {/* Occupation */}
      <div style={{ margin: "1em" }}>
        <Autocomplete
          options={occupations}
          groupBy={(option) => option.category}
          getOptionLabel={(option) => option.title || ""}
          value={
            isOtherOccupation && typeof formData.occup === "string"
              ? { title: formData.occup, value: formData.occup, category: "Others" }
              : typeof formData.occup === "object" ? formData.occup : null
          }
          onChange={(e, newValue) => {
            if (newValue?.value === "Others") {
              setIsOtherOccupation(true);
              setFormData((prev) => ({ ...prev, occup: "Others" }));
            } else if (newValue) {
              setIsOtherOccupation(false);
              setFormData((prev) => ({ ...prev, occup: newValue }));
            } else {
              setIsOtherOccupation(false);
              setFormData((prev) => ({ ...prev, occup: null }));
            }
          }}
          renderGroup={(option) => (
            <li key={option.key}>
              <GroupHeader>{option.group}</GroupHeader>
              <GroupItems>{option.children}</GroupItems>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label="Occupation"
              variant="outlined"
              error={!!validateError.occup}
              helperText={validateError.occup}
              FormHelperTextProps={{ style: { fontSize: "14px", color: "red" } }}
              InputLabelProps={{
                sx: {
                  ".MuiInputLabel-asterisk": {
                    color: "red",
                    fontSize: "1.2em",
                  }
                }
              }}
              required
            />
          )}
        />
        {/* Manual occupation input if Others selected */}
        {isOtherOccupation && (
          <TextField
            fullWidth
            label="Please specify occupation"
            id="occup"
            variant="outlined"
            value={typeof formData.occup === "string" && formData.occup !== "Others" ? formData.occup : ""}
            onChange={(e) => {
              const manualValue = e.target.value;
              setFormData((prev) => ({
                ...prev,
                occup: manualValue,
              }));
            }}
            error={!!validateError.occup}
            helperText={isOtherOccupation && !formData.occup ? "Occupation is required" : ""}
            FormHelperTextProps={{ style: { fontSize: "14px", color: "red" } }}
            style={{ marginTop: "1em" }}
            sx={{
              '& .MuiInputBase-input': {
                fontSize: '16px',
              }
            }}
          />
        )}
      </div>

      {/* Work Location */}
      <div style={{ margin: "1em" }}>
        <TextField
          fullWidth
          label="Work Location"
          name="w_place"
          value={formData.w_place}
          onChange={handleChange}
          variant="outlined"
          error={!!validateError.w_place}
          helperText={validateError.w_place}
          FormHelperTextProps={{
            style: { fontSize: "14px", color: "red" },
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '16px',
            }
          }}
          InputLabelProps={{
            sx: {
              ".MuiInputLabel-asterisk": {
                color: "red",
                fontSize: "1.2em",
              }
            }
          }}
          required
        />
      </div>

      {/* Income */}
      <div style={{ margin: "1em" }}>
        <Autocomplete
          options={incomeRanges}
          getOptionLabel={(o) => (o?.title ? o.title : "")}
          getOptionSelected={(option, value) => option?.value === value?.value}
          value={formData.income || null}
          onChange={(e, v) => setFormData((prev) => ({ ...prev, income: v }))}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label="Income"
              variant="outlined"
              error={!!validateError.income}
              helperText={validateError.income}
              FormHelperTextProps={{
                style: { fontSize: "14px", color: "red" },
              }}
            />
          )}
        />
      </div>

      {/* Company Name */}
      <div style={{ margin: "1em" }}>
        <TextField
          fullWidth
          label="Company Name"
          name="company_name"
          value={formData.company_name}
          onChange={handleChange}
          variant="outlined"
          error={!!validateError.company_name}
          helperText={validateError.company_name}
          FormHelperTextProps={{
            style: { fontSize: "14px", color: "red" },
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '16px',
            }
          }}
          InputLabelProps={{
            sx: {
              ".MuiInputLabel-asterisk": {
                color: "red",
                fontSize: "1.2em",
              }
            }
          }}
          required
        />
      </div>

      {/* Sector */}
      <div style={{ margin: "1em" }}>
        <Autocomplete
          options={sectors || []}
          groupBy={(option) => option.category}
          getOptionLabel={(option) => option.title || ""}
          value={
            isOtherSector && typeof formData.work_sector === "string"
              ? { title: formData.work_sector, value: formData.work_sector, category: "Others" }
              : typeof formData.work_sector === "object" ? formData.work_sector : null
          }
          onChange={(e, newValue) => {
            if (newValue?.value === "Others") {
              setIsOtherSector(true);
              setFormData((prev) => ({ ...prev, work_sector: "Others" }));
            } else if (newValue) {
              setIsOtherSector(false);
              setFormData((prev) => ({ ...prev, work_sector: newValue }));
            } else {
              setIsOtherSector(false);
              setFormData((prev) => ({ ...prev, work_sector: null }));
            }
          }}
          renderGroup={(option) => (
            <li key={option.key}>
              <GroupHeader>{option.group}</GroupHeader>
              <GroupItems>{option.children}</GroupItems>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label="Work Sector"
              variant="outlined"
              error={!!validateError.work_sector}
              helperText={validateError.work_sector}
              FormHelperTextProps={{ style: { fontSize: "14px", color: "red" } }}
              InputLabelProps={{
                sx: {
                  ".MuiInputLabel-asterisk": {
                    color: "red",
                    fontSize: "1.2em",
                  }
                }
              }}
              required
            />
          )}
        />
        {/* Manual occupation input if Others selected */}
        {isOtherSector && (
          <TextField
            fullWidth
            label="Please specify sector"
            id="work_sector"
            variant="outlined"
            value={typeof formData.work_sector === "string" && formData.work_sector !== "Others" ? formData.work_sector : ""}
            onChange={(e) => {
              const manualValue = e.target.value;
              setFormData((prev) => ({
                ...prev,
                work_sector: manualValue,
              }));
            }}
            error={!!validateError.work_sector}
            helperText={isOtherSector && !formData.work_sector ? "Sector is required" : ""}
            FormHelperTextProps={{ style: { fontSize: "14px", color: "red" } }}
            style={{ marginTop: "1em" }}
            sx={{
              '& .MuiInputBase-input': {
                fontSize: '16px',
              }
            }}
          />
        )}
      </div>

      {/* Education */}
      <div style={{ margin: "1em" }}>
        <Autocomplete
          options={educationOptions || []}
          groupBy={(option) => option.category}
          getOptionLabel={(option) => option.title || ""}
          value={
            isOtherEducation && typeof formData.educ === "string"
              ? { title: formData.educ, value: formData.educ, category: "Others" }
              : typeof formData.educ === "object" ? formData.educ : null
          }
          onChange={(e, newValue) => {
            if (newValue?.value === "Others") {
              setIsOtherEducation(true);
              setFormData((prev) => ({ ...prev, educ: "Others" }));
            } else if (newValue) {
              setIsOtherEducation(false);
              setFormData((prev) => ({ ...prev, educ: newValue }));
            } else {
              setIsOtherEducation(false);
              setFormData((prev) => ({ ...prev, educ: null }));
            }
          }}
          renderGroup={(option) => (
            <li key={option.key}>
              <GroupHeader>{option.group}</GroupHeader>
              <GroupItems>{option.children}</GroupItems>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label="Education"
              variant="outlined"
              error={!!validateError.educ}
              helperText={validateError.educ}
              FormHelperTextProps={{ style: { fontSize: "14px", color: "red" } }}
              InputLabelProps={{
                sx: {
                  ".MuiInputLabel-asterisk": {
                    color: "red",
                    fontSize: "1.2em",
                  }
                }
              }}
              required
            />
          )}
        />
        {/* Manual occupation input if Others selected */}
        {isOtherEducation && (
          <TextField
            fullWidth
            label="Please specify education"
            id="educ"
            variant="outlined"
            value={typeof formData.educ === "string" && formData.educ !== "Others" ? formData.educ : ""}
            onChange={(e) => {
              const manualValue = e.target.value;
              setFormData((prev) => ({
                ...prev,
                educ: manualValue,
              }));
            }}
            error={!!validateError.educ}
            helperText={isOtherEducation && !formData.educ ? "Education is required" : ""}
            FormHelperTextProps={{ style: { fontSize: "14px", color: "red" } }}
            style={{ marginTop: "1em" }}
            sx={{
              '& .MuiInputBase-input': {
                fontSize: '16px',
              }
            }}
          />
        )}
      </div>

      {/* Higher Educational Qualification */}
      <div style={{ margin: "1em" }}>
        <TextField
          fullWidth
          label="Higher Educational Qualification"
          name="higher_education_qualification"
          value={formData.higher_education_qualification}
          onChange={handleChange}
          variant="outlined"
          error={!!validateError.higher_education_qualification}
          helperText={validateError.higher_education_qualification}
          FormHelperTextProps={{
            style: { fontSize: "14px", color: "red" },
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '16px',
            }
          }}
          InputLabelProps={{
            sx: {
              ".MuiInputLabel-asterisk": {
                color: "red",
                fontSize: "1.2em",
              }
            }
          }}
          required
        />
      </div>
    </div>
  );
}
